import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bepatient-delete-event-popup',
  templateUrl: './delete-event-popup.component.html',
  styleUrls: ['./delete-event-popup.component.scss'],
  standalone: false
})
export class DeleteEventPopupComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() accept: string;
  @Input() discard: string;
  @Output() validated = new EventEmitter<boolean>();
}
